import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Es para principiantes?',
  answer: 'Sí. Empiezas con vocabulario y frases simples, y avanzas a intermedio con práctica.'
}, {
  question: '¿Necesito saber algo antes?',
  answer: 'No. Está pensado para empezar desde cero y construir sin frustración.'
}, {
  question: '¿Tengo que estudiar muchas horas?',
  answer: 'No. El sistema está diseñado para 10–15 minutos diarios.'
}, {
  question: '¿Viene en audio?',
  answer: 'No por ahora. Es 100% PDF, compatible con celular, tablet y computadora.'
}, {
  question: '¿Sirve si estoy ocupado/a?',
  answer: 'Sí. Por eso incluye el Planner 30 días anti-abandono.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Descarga digital inmediata.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-8 md:py-14 px-4" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-36">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-37">
          {faqs.map((faq, index) => <div key={index} className="bg-[#F8F9FA] rounded-xl overflow-hidden" data-id="element-38">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-5 flex items-center justify-between text-left cursor-pointer" data-id="element-39">
                <span className="font-semibold text-[#1A1A2E]" data-id="element-40">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-41">
                  <ChevronDownIcon className="w-5 h-5 text-[#4A4A5A]" data-id="element-42" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-44">
                    <p className="px-5 pb-5 text-[#4A4A5A]" data-id="element-45">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}